export interface LegacyPhoto {
    id: string;
    src: string;
    title: string;
    caption: string;
    era?: string;
    /** Featured photos span a larger grid cell */
    featured?: boolean;
}

/**
 * Heritage photos for The Great Emmanuel Hospital page.
 * Add new entries here as photos become available (designed for ~7 images).
 */
export const hospitalLegacyPhotos: LegacyPhoto[] = [
    {
        id: 'mgbeke-onwuka-outdoors',
        src: '/image/legacy/mgbeke-onwuka-outdoors.jpg?v=2',
        title: 'Elder D. I. Mgbeke with Dr Onwuka',
        caption: 'Elder David I. Mgbeke and Dr Onwuka — founding partners whose shared vision grew into The Great Emmanuel Hospital.',
        era: 'Founding era',
        featured: true,
    },
    {
        id: 'mgbeke-onwuka-indoor',
        src: '/image/legacy/mgbeke-onwuka-indoor.jpg?v=2',
        title: 'Elder D. I. Mgbeke with Dr Onwuka',
        caption: 'A portrait of the founders whose commitment to service laid the foundation for decades of community care.',
        era: 'Early years',
    },
    {
        id: 'onwuka-mgbeokwere',
        src: '/image/legacy/onwuka-mgbeokwere.jpg',
        title: 'Dr Onwuka with Mr Mgbeokwere (Ochendo)',
        caption: 'Dr Onwuka with Mr Mgbeokwere (Ochendo) — Elder D. I. Mgbeke\'s boss and a key figure in the hospital\'s early establishment.',
        era: 'Founding era',
    },
    {
        id: 'facility-inspection-1990s',
        src: '/image/legacy/facility-inspection-1990s.jpg?v=2',
        title: 'Facility Inspection by Foreign Visitors',
        caption: 'Inspection of the facility by foreign visitors in the early 1990s.',
        era: 'Early 1990s',
    },
    {
        id: 'mgbeke-first-attempt',
        src: '/image/legacy/mgbeke-first-attempt.jpg',
        title: 'Elder D. I. Mgbeke\'s First Attempt at Saving Lives',
        caption: 'A young Elder D. I. Mgbeke among medicines and supplies — the beginning of a lifelong mission to heal and serve.',
        era: 'Early career',
    },
    {
        id: 'mgbeke-nurses-team',
        src: '/image/legacy/mgbeke-nurses-team.jpg',
        title: 'Elder D. I. Mgbeke and His Team of Nurses',
        caption: 'Elder D. I. Mgbeke and his team of nurses at the hospital — the caring hands behind decades of community health service.',
        era: 'Hospital years',
    },
    // Add more photos below as they become available:
];
